<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                {
                    text: 'Inventory Insight',
                    disable: true
                }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <!-- <v-icon color="primary" class="ml-2 mr-2"
                                    >extension</v-icon
                                > -->
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        dense
                                        v-model="search"
                                        append-outer-icon="refresh"
                                        @click:append-outer="
                                            refreshCurrentPage()
                                        "
                                        label="Search"
                                        clearable
                                        hide-details
                                        :disabled="
                                            $apollo.queries
                                                .tenantPlantInventoryByPlant
                                                .loading
                                        "
                                        @keydown.enter="refreshCurrentPage()"
                                        @click:clear="onClearSearch()"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                    cols="6"
                                    sm="2"
                                    md="3"
                                    align-self="start"
                                >
                                    <v-autocomplete
                                        v-model="selectedPotSizes"
                                        :items="tenantPotSizes.edges"
                                        item-value="node.id"
                                        item-text="node.potSizeCm"
                                        :disabled="
                                            $apollo.queries.tenantPotSizes
                                                .loading
                                        "
                                        label="Pot Size (cm)"
                                        multiple
                                        dense
                                        clearable
                                        hide-details
                                    >
                                    </v-autocomplete
                                ></v-col>
                                <v-col
                                    cols="6"
                                    sm="2"
                                    md="3"
                                    align-self="start"
                                >
                                    <v-autocomplete
                                        v-model="selectedColors"
                                        :items="tenantColors.edges"
                                        item-value="node.id"
                                        item-text="node.color"
                                        :disabled="
                                            $apollo.queries.tenantColors.loading
                                        "
                                        label="Color"
                                        multiple
                                        dense
                                        clearable
                                        hide-details
                                    >
                                    </v-autocomplete
                                ></v-col>
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries
                                            .tenantPlantInventoryByPlant.loading
                                    "
                                    :items="tenantPlantInventoryByPlant.edges"
                                    :options.sync="dataTableOptions"
                                    :server-items-length="
                                        tenantPlantInventoryByPlant.totalCount
                                    "
                                    loading-text="Loading... Please wait"
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries
                                                .tenantPlantInventoryByPlant
                                                .loading
                                    }"
                                >
                                    <template
                                        v-slot:item.node.notEnoughInventoryAlert="{
                                            item
                                        }"
                                    >
                                        <v-icon
                                            color="warning"
                                            small
                                            v-if="
                                                item.node
                                                    .notEnoughInventoryAlert
                                            "
                                            >warning</v-icon
                                        >
                                    </template>

                                    <!-- action-->
                                    <template v-slot:item.action="{ item }">
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                showPlantWeeklyInventory(
                                                    item.node
                                                )
                                            "
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>

        <PlantWeeklyInventoryDialog
            :dialog.sync="plantWeeklyInventoryDialog"
            :plantInventoryNodeObject.sync="selectedPlantInventoryNode"
            :key="
                selectedPlantInventoryNode ? selectedPlantInventoryNode.id : 1
            "
        ></PlantWeeklyInventoryDialog>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import PlantWeeklyInventoryDialog from "@/components/customized/PlantWeeklyInventoryDialog.vue";

export default {
    name: "inventory-by-week",
    components: {
        PlantWeeklyInventoryDialog
    },

    apollo: {
        tenantPotSizes: {
            query: gql`
                query tenantPotSizes {
                    tenantPotSizes(orderBy: "potSizeCm") {
                        edges {
                            node {
                                id
                                potSizeCm
                            }
                        }
                    }
                }
            `
        },
        tenantColors: {
            query: gql`
                query tenantColors {
                    tenantColors(orderBy: "color") {
                        edges {
                            node {
                                id
                                color
                            }
                        }
                    }
                }
            `
        },
        tenantPlantInventoryByPlant: {
            query: gql`
                query tenantPlantInventoryByPlant(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $search: String
                    $potSize: [ID]
                    $color: [ID]
                    $orderBy: String
                ) {
                    tenantPlantInventoryByPlant(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        potSize: $potSize
                        color: $color
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                notEnoughInventoryAlert
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10,
                    potSize: this.selectedPotSizes,
                    color: this.selectedColors
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantPlantInventoryByPlant,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            isLoadingInventory: false,
            selectedPotSizes: [],
            selectedColors: [],

            search: "",

            plantWeeklyInventoryDialog: false,
            selectedPlantInventoryNode: null,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            tenantPotSizes: {
                edges: []
            },
            tenantColors: {
                edges: []
            },

            tenantPlantInventoryByPlant: {},

            headers: [
                // {
                //     text: "Week",
                //     value: "node.readySalesWeekStartDate",
                //     sortable: true
                // },
                {
                    text: "Plant Species",
                    value: "node.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    align: "left",
                    value: "node.plant.name",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    value: "node.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.tag.tag",
                    sortable: true
                },
                {
                    text: "Availability Warning",
                    value: "node.notEnoughInventoryAlert",
                    align: "center",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // inventory: function() {
        //     return this.$store.state.inventory.inventory;
        // }
        yearWeekText() {
            let _yearWeek = this.$route.params.yearWeek;
            return _yearWeek.slice(0, 4) + "-W" + _yearWeek.slice(4, 6);
        }
    },
    watch: {
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        },
        selectedPotSizes() {
            this.refreshCurrentPage();
        },
        selectedColors() {
            this.refreshCurrentPage();
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        initialize() {
            // this.fetchInventory();
        },

        // fetchInventory() {
        //     // fetch plants
        //     this.isLoadingInventory = true;
        //     this.$store
        //         .dispatch("inventory/fetchGrowthTaskInventoryByPlant")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingInventory = false));
        // }

        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(sortBy, sortDesc, page, itemsPerPage);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlantInventoryByPlant.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlantInventoryByPlant.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.readySalesInventory":
                    _orderBy = "readySalesInventory";
                    break;
                case "node.orderedInventory":
                    _orderBy = "orderedInventory";
                    break;
                case "node.readySalesWeekStartDate":
                    _orderBy = "readySalesWeekStartDate";
                    break;
                case "node.notEnoughInventoryAlert":
                    _orderBy = "notEnoughInventoryAlert";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantPlantInventoryByPlant.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.search,
                potSize: this.selectedPotSizes,
                color: this.selectedColors
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantPlantInventoryByPlant.skip = false;
            this.$apollo.queries.tenantPlantInventoryByPlant.refresh();

            // update this.page
            this.page = page;
        },

        showPlantWeeklyInventory(node) {
            this.selectedPlantInventoryNode = node;
            this.plantWeeklyInventoryDialog = true;
        }
    }
};
</script>